import React from "react";
import Helmet from "react-helmet";

const CustomHelmet = ({
  keywords,
  description,
  author,
  title,
  redirectLink,
  canonical,
}) => {
  return (
    <Helmet>
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      <meta name="author" content={author} />
      <link rel="canonical" href={canonical} />
      <meta http-equiv="refresh" content={redirectLink} />
      <title>{title}</title>
    </Helmet>
  );
};

CustomHelmet.defaultProps = {
  title:
    "Arcaptor Technologies | Crafting Futures with AI, Shaping Worlds in the Metaverse.",
  keywords:
    "Arcaptor Technologies | Crafting Futures with AI, Shaping Worlds in the Metaverse.",
  description:
    "At Arcaptor, we design advanced AI and Metaverse solutions that address real-world challenges. Our mission is to blend technology with impact.",
  author: "Team Arcaptor Technologies",
};

export default CustomHelmet;
